import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './Tags.css';

export default function Tags() {
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tags')
      .then(res => setGrouped(res.data.grouped || {}))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const letters = Object.keys(grouped).sort();

  if (loading) return <div className="page-loading"><div className="spinner" /></div>;

  return (
    <div className="tags-page container">
      <div className="tags-page__header">
        <h1>Browse by Tag</h1>
        <p>Find recipes by exploring all tags alphabetically</p>
      </div>

      {letters.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🏷️</div>
          <h3>No tags yet</h3>
          <p>Tags will appear here as you import recipes.</p>
        </div>
      ) : (
        <>
          {/* Alphabet quick jump */}
          <div className="tags-page__alphabet">
            {letters.map(letter => (
              <a key={letter} href={`#letter-${letter}`} className="tags-page__letter-jump">
                {letter}
              </a>
            ))}
          </div>

          {/* Tag groups */}
          <div className="tags-page__groups">
            {letters.map(letter => (
              <div key={letter} className="tags-page__group" id={`letter-${letter}`}>
                <h2 className="tags-page__group-letter">{letter}</h2>
                <div className="tags-page__tag-list">
                  {grouped[letter].map(tag => (
                    <Link
                      key={tag}
                      to={`/search?q=${encodeURIComponent(tag)}`}
                      className="tags-page__tag"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
